
const TEST_API_ENDPOINT = 'http://127.0.0.1:9';
const DEFAULT_API_ENDPOINT = process.env.NODE_ENV === 'test'
    ? TEST_API_ENDPOINT
    : 'https://api.combattv.co.nz';

/**
 * API base URL used by frontend services.
 * Tests default to a closed localhost port so missing env cannot contact production.
 */
export const BASE_URL = process.env.REACT_APP_API_ENDPOINT || DEFAULT_API_ENDPOINT;

export const APP_ROUTES: { name: string, route: string }[] = [
    { name: 'Home', route: '/' },
    { name: 'Videos', route: '/videos' },
    { name: 'My Library', route: '/my-library' },
    { name: 'Fight Cards', route: '/fight-cards' },
    { name: 'Plans', route: '/pricing' },
    { name: 'Contact', route: '/contact' }
];

export enum Routes {
    HOME = '/',
    VIDEO_SEARCH = '/video-search',
    VIDEOS = '/videos',
    NZ_COMBAT_SPORTS = '/nz-combat-sports',
    FIGHT_CARDS = '/fight-cards',
    FIGHT_CARD_EVENT = '/fight-cards/event',
    WATCH = '/watch',
    CONTACT = '/contact',
    PROFILE = '/profile',
    PROFILE_BILLING = '/profile/billing',
    PROFILE_MANAGE_ACCOUNT = '/profile/manage-account',
    MY_LIBRARY = '/my-library',
    MY_PURCHASES = '/my-purchases',
    PRICING = '/pricing',
    JOIN = '/join',
    LOGIN = '/login',
    FORGOT_PASSWORD = '/forgot_password',
    REGISTER = '/register',
    ADMIN = '/admin',
    ADMIN_ANALYTICS = '/admin/analytics',
    ADMIN_COLLECTIONS = '/admin/collections',
    ADMIN_DIAGNOSTICS = '/admin/diagnostics',
    ADMIN_EMAIL_LOGS = '/admin/email-logs',
    ADMIN_EVENTS = '/admin/events',
    ADMIN_EVENT_TYPES = '/admin/event-types',
    ADMIN_HIGHLIGHTS = '/admin/highlights',
    ADMIN_IMAGES = '/admin/images',
    ADMIN_LOCATIONS = '/admin/locations',
    ADMIN_PAYMENT_OPERATIONS = '/admin/payment-operations',
    ADMIN_PAYMENT_DISPUTES = '/admin/payment-disputes',
    ADMIN_PARTICIPANTS = '/admin/participants',
    ADMIN_PARTICIPANT_ATTRIBUTES = '/admin/participant-attributes',
    ADMIN_PARTICIPANT_ATTRIBUTE_VALUES = '/admin/participant-attribute-values',
    ADMIN_PROMOS = '/admin/promos',
    ADMIN_SITE_CONFIGURATION = '/admin/site-configuration',
    ADMIN_CONTENT_PROCESSING_CONFIG = '/admin/services/content-processing/config',
    ADMIN_CONTENT_PROCESSING_ACTIVITY = '/admin/services/content-processing/activity',
    ADMIN_STORAGE = '/admin/storage',
    ADMIN_VIDEO_ANALYTICS = '/admin/video-analytics',
    ADMIN_VIDEO_PLAYBACK = '/admin/video-playback',
    ADMIN_TAGS = '/admin/tags',
    ADMIN_USERS = '/admin/users',
    ADMIN_USER_CREATE = '/admin/users/new',
    ADMIN_USER_DETAIL = '/admin/users/:userId',
    ADMIN_USER_WATCH_HISTORY = '/admin/users/:userId/watch-history',
    ADMIN_VIDEO_PARTICIPANT_TYPES = '/admin/video-participant-types',
    ADMIN_VIDEO_PARTICIPANTS = '/admin/video-participants',
    ADMIN_VIDEOS = '/admin/videos',
    ADMIN_VIDEO_NEW = '/admin/videos/new',
    ADMIN_VIDEO_UPLOAD = '/admin/video-upload'
}
